import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=57626618&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"
import style0 from "./Empresas.vue?vue&type=style&index=0&id=57626618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57626618",
  null
  
)

export default component.exports